import getUTM from '%/utils/utm';
import getGADParams from '%/utils/gadTracking';
import getFbclidCookie from '%/utils/fbclid';
import { current_unit_slug } from '%/utils/current_unit';

const getStateData = (state, props, handleDynamicData) => {
  const stateData = {
    name: state.name,
    email: state.email,
    phone: state.phone,
    unit: state.unit || current_unit_slug(),
    mailing: state.mailing,
    phoning: state.phoning,
    whatsapping: state.whatsapping,
    version: state.selectedVariant,
    'veiculo-na-troca': state['veiculo-na-troca'],
  };

  if (props.showCpf) {
    stateData.cpf = state.cpf;
  }

  if (props.showDataPermissions) {
    stateData.data_permissions = state.dataPermissions;
  }

  if (typeof handleDynamicData !== 'undefined') {
    const dynamicData = handleDynamicData(state);
    return { ...stateData, ...dynamicData };
  }

  return stateData;
};

const getPropsData = props => {
  const propsData = {
    product: props.product,
    bait: -5,
    channel: props.channel,
    category: props.category,
    brand: props.brand,
    utmz: getUTM(),
    gad_tracking: getGADParams(),
    fbclid: getFbclidCookie(),
  };

  const propsMapping = {
    cloneId: 'product_id',
    modelYear: 'modelYear',
    productCode: 'productCode',
    fcaOfferId: 'fca_offer_id',
    subOrigin: 'SubOrigem__c',
  };

  Object.entries(propsMapping).forEach(([propKey, dataKey]) => {
    if (props[propKey]) {
      propsData[dataKey] = props[propKey];
    }
  });

  return propsData;
};

export const getPayload = (state, props, handleDynamicData) => {
  const propsData = getPropsData(props);
  const stateData = getStateData(state, props, handleDynamicData);

  const payload = { ...stateData, ...propsData };

  return payload;
};
